<template>
  <nuttrema-layout-form-standard :edit="true" :saveError="StuffToEatContents.saveError" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :rules="rules">

        <section>
          <h4 class="section-title">{{ $t('label.add_schedule_legend') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.schedule_time')" prop="start_time">
              <el-col :span="8">
                <el-time-picker
                   v-model="formData.start_time"
                   class="w-100"
                   format="HH:mm"
                   type="fixed-time"
                   value-format="HH:mm"
                  :picker-options="{
                    start:'00:00',
                    end:'23:45',
                  }">
                </el-time-picker>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.title')" prop="title">
              <el-col :span="24">
                <el-input
                  class="w-100"
                  v-model="formData.title">
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.note')" prop="note">
              <el-col :span="24">
                <el-input
                   autosize
                   class="w-100"
                   type="textarea"
                   v-model="formData.note"
                  :placeholder="$t('label.schedule_note')"
                  :autosize="{ minRows: 2, maxRows: 5 }">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.meal_contents') }}</h4>
          <div v-for="stuffToEatContent in _get(StuffToEatContents, 'data', [])" class="section-items stuff-to-eat-complex-item">

            <stuff-to-eat-info-small-card
               slot="left"
              :reactive="false"
              :details="stuffToEatContent.Content">
            </stuff-to-eat-info-small-card>

            <el-form-item :label="$t('label.amount')" prop="amount">
              <el-col :span="12">
                <el-input-number
                  class="w-100"
                  v-model="formData.schedule_data.contents['content-' + stuffToEatContent.content_id].amount"
                  @change="handleAmountChange">
                </el-input-number>
              </el-col>
              <el-col :span="3" :offset="1">
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content" v-html="_markdown.render($t('label.schedule_amount_help'))"></div>
                  <el-button type="primary" icon="far fa-info" size="small" plain circle style="padding: 4px 7px"></el-button>
                </el-tooltip>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('label.serving_size')" prop="entity_serving_size_id">
              <el-col :span="24">
                <el-select
                  class="w-100"
                  v-model="formData.schedule_data.contents['content-' + stuffToEatContent.content_id].entity_serving_size_id"
                  @change="handleServingSizeChange">
                  <template
                    v-for="servingGroup in stuffToEatContent.Content.EntityServingSizes.available_serving"
                    v-if="!_isEmpty(servingGroup.list)">
                    <el-option-group
                      :label="servingGroup.title"
                      :key="servingGroup.key">
                      <el-option
                        v-for="item in servingGroup.list"
                        :label="formatServingSizeLabel(item)"
                        :key="item.id"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </template>
                </el-select>
              </el-col>
            </el-form-item>

          </div>
        </section>

        <div class="el-form__help">
          <p v-html="_markdown.renderInline($t('label.stuff_to_eat_complex_schedule_help'))"></p>
        </div>

        <section>
            <h4 class="section-title">{{ $t('label.nutrition_prediction_for', { date: activeDay }) }}</h4>
            <div class="section-items is-slim-padding">
              <nuttrema-loader
                 v-if="!_get(ProgramDaySchedulesSummaryPrediction, 'ready', false)"
                 theme="relative"
                :showText="false">
              </nuttrema-loader>
              <nutrition-facts
                 v-else
                 mode="quantity"
                 v-loading="ProgramDaySchedulesSummaryPrediction.fetching"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(255,255,255, 0.8)"
                :productNutritionFacts="ProgramDaySchedulesSummaryPrediction.data">
              </nutrition-facts>
            </div>
          </section>
      </el-form>
    </template>

    <template slot="footer">

      <div v-if="scheduleID" class="footer-row">
        <div>
          <el-button
             type="primary"
             size="small"
            :loading="isSaving"
            @click="submitForm">
            {{ $t('label.save_changes') }}
          </el-button>
          <el-button
            size="small"
            type="text"
            @click="cancelChanges">
            <span v-if="showDoneButton">{{ $t('label.done') }}</span>
            <span v-else>{{ $t('label.cancel') }}</span>
          </el-button>
        </div>
        <div>
          <popover-question-alert
             buttonTitle="label.delete"
             buttonType="danger"
             popoverWidth="280"
             popoverTitle="label.delete"
             popoverText="label.delete_sure"
             popoverPlacement="top-end"
             buttonSize="small"
            :popoverShouldShow="true"
            @confirmed="handleRemoveScheduleEvent">
          </popover-question-alert>
        </div>
      </div>

      <div v-else class="footer-row">
        <el-button
           type="primary"
           size="small"
          :loading="isSaving"
          @click="submitForm">
          {{ $t('label.save') }}
        </el-button>
        <el-button
          size="small"
          type="text"
          @click="$emit('someCrazyEvent')">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>

    </template>
    <!-- end ~ footer -->

  </nuttrema-layout-form-standard>
</template>

<script>
import Vue from 'vue';
import { each, assign, omitBy, isNil, get, first, find, last } from 'lodash';

import moment from 'moment';

import { formatTime } from 'utils';
import { TIME_CONSTANTS } from 'constants/time';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import NutritionFacts from 'components/ui/nutrition-information/nutrition-facts';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';
import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';

export default {
  name: 'form-cred-stuff-to-eat-complex-schedule',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    scheduleID: {
      required: false,
      default: null,
    },
    entityID: {
      required: false,
      default: null,
    },
    ProgramDay: {
      required: false,
    },
    StuffToEatContents: {
      required: false,
      default: null,
    },
    ProgramDaySchedule: {
      required: false,
      default: null,
    },
    ProgramDaySchedules: {
      required: false,
      default: null,
    },
    saveError: {
      required: false,
      default: null,
    },
    edit: {
      required: false,
      default: true,
    },
  },
  components: {
    NutritionFacts,
    NuttremaLoader,
    PopoverQuestionAlert,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        title: null,
        note: null,
        schedule_type_code: 'stuff_to_eat_complex',
        start_time: null,
        schedule_data: {
          entity_id: null,
          contents: {},
        },
      },
      rules: {
        start_time: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.start_time', true),
          },
        ],
      },
    };
  },
  computed: {
    ProgramDaySchedulesSummaryPrediction() {
      return this.$store.getters.ProgramDaySchedulesSummaryPrediction(this.id);
    },
    activeDay() {
      const dayDate = get(this.ProgramDay, 'data.day');
      const dayNumber = get(this.ProgramDay, 'data.day_number', 0);
      return dayDate ? moment(dayDate).format('LL') : this.$t('label.day_no', { value: dayNumber });
    },
  },
  methods: {
    formatServingSizeLabel(servingSize) {
      const label = servingSize.title || servingSize.description;
      return `${label} (${servingSize.weight_gr}g)`;
    },
    getSchedulePredictionData() {
      let data = `${this.entityID},`;
      let count = 0;
      each(this.formData.schedule_data.contents, (content) => {
        if (count > 0) data += ',';
        data += `${content.entity_id}~${content.entity_serving_size_id}~${content.amount}`;
        count += 1;
      });
      return data;
    },
    fetchProgramDaySchedulesSummaryPrediction() {
      const scheduleData = this.getSchedulePredictionData();
      const data = {
        id: this.id,
        type: this.type,
        dayID: this.dayID,
        params: {
          schedule_type_code: 'stuff_to_eat_complex',
          schedule_data: scheduleData,
        },
      };

      if (this.scheduleID) {
        assign(data.params, { schedule_id: this.scheduleID });
      }

      this.$store.dispatch('GetProgramDaySchedulesSummaryPrediction', data);
    },
    getFormData() {
      const contents = [];

      each(this.formData.schedule_data.contents, (item) => {
        contents.push(item);
      });

      return assign(omitBy(this.formData, isNil), {
        schedule_data: {
          entity_id: this.entityID,
          contents,
        },
      });
    },
    handleRemoveScheduleEvent() {
      const data = {
        id: this.id,
        type: this.type,
        dayID: this.dayID,
        scheduleID: this.scheduleID,
      };
      this.$emit('removeSchedule', data);
    },
    handleAmountChange() {
      this.$nextTick(() => {
        this.fetchProgramDaySchedulesSummaryPrediction();
      });
    },
    handleServingSizeChange() {
      this.$nextTick(() => {
        this.fetchProgramDaySchedulesSummaryPrediction();
      });
    },
    nextScheduleTime() {
      const schedules = get(this.ProgramDaySchedules, 'data', []);
      const lastSchedule = last(schedules);
      const lastScheduleTime = formatTime(get(lastSchedule, 'Time', TIME_CONSTANTS.DEFAULT_START));
      return moment(lastScheduleTime, 'HH:mm').add(TIME_CONSTANTS.INTERVAL, 'hours').format('HH:mm');
    },
    setFormData() {
      return new Promise((resolve, reject) => {
        try {
          let schedule = null;

          const schedules = get(this.ProgramDaySchedule, 'data.Schedules', false);

          if (schedules) {
            schedule = first(schedules);
            Vue.set(this.formData, 'title', schedule.title);
            Vue.set(this.formData, 'note', schedule.note);
            Vue.set(this.formData, 'start_time', formatTime(schedule.start_time));
          } else {
            Vue.set(this.formData, 'start_time', this.nextScheduleTime());
          }

          each(this.StuffToEatContents.data, (content) => {
            let entityID = get(content, 'content_id', null);
            let amount = get(content, 'amount', 0);
            let entityServingSizeID = get(content, 'content_serving_size_id', null);

            if (schedule) {
              const entity = find(schedule.Children, item => entityID === item.entity_id);
              console.log(schedule, entity, entityID);
              entityID = get(entity, 'entity_id', entityID);
              amount = get(entity, 'amount', 0);
              entityServingSizeID = get(entity, 'entity_serving_size_id', entityServingSizeID);
            }

            Vue.set(this.formData.schedule_data.contents, `content-${content.content_id}`, {
              entity_id: entityID,
              amount,
              entity_serving_size_id: entityServingSizeID,
            });
          });
          // end ~ each

          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.stateData = this.ProgramDaySchedules;
    this.formRef = 'form-cred-stuff-to-eat-complex-schedule';

    this.setFormData().then(() => {
      this.fetchProgramDaySchedulesSummaryPrediction();
    });
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .stuff-to-eat-complex-item {
    padding-bottom: 1em;
    margin-bottom: 0.75em;
    border-bottom: 1px solid $gray-lighter;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    .stuff-to-eat-info-small-card {
      margin-bottom: 1em;
      // padding-left: 0.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/cred/form-cred-stuff-to-eat-complex-schedule.vue